import PurchaseAppService from '../../../../application/platform/scp/purchase/purchase-app-service';
import { FileAttachmentsTable } from '../../shared/file-attachments-table';
import { FileAttachmentsService } from '../../shared/use-file-attachments';

const PURCHASE_FILES_SERVICE: FileAttachmentsService = {
    documentTypeGroup: 1,
    list: (id) => PurchaseAppService.listPurchaseFiles({ id, page: 1, pageSize: 200 }).then((response) => response.items || []),
    add: PurchaseAppService.addFilePurchase,
    remove: PurchaseAppService.deleeteFilePurchase,
};

export default function PurchaseFileDataTable({ purchaseId }: { purchaseId?: string }) {
    return <FileAttachmentsTable entityId={purchaseId ? Number(purchaseId) : undefined} service={PURCHASE_FILES_SERVICE} uploadId="file-upload-atachment" />;
}
